import React,{useState,useEffect} from 'react'
import Partner from '../../components/Partner'
import PartnerService from '../../services/partners.service';


const IndustryPartner = () => {
  const [list,setList]=useState([]);

    // const industryPartners=[
    //     "./img/partners/industry-1.png",
    //     "./img/partners/industry-2.png",
    //     "./img/partners/industry-3.png",
    //     "./img/partners/industry-4.png",

    //     "./img/partners/industry-1.png",
    //     "./img/partners/industry-2.png",
    //     "./img/partners/industry-3.png",
    //     "./img/partners/industry-4.png",

    //     "./img/partners/industry-1.png",
    //     "./img/partners/industry-2.png",
    //     "./img/partners/industry-3.png",
    //     "./img/partners/industry-4.png",

    //     "./img/partners/industry-1.png",
    //     "./img/partners/industry-2.png",
    //     "./img/partners/industry-3.png",
    //     "./img/partners/industry-4.png", 

    // ];

    useEffect(()=>{
      PartnerService.industryList()
      .then(res=>setList(res?.data))
      .catch(err=>console.log(err));
    },[])

  return (
   <>
       <Partner 
     title={"Industry Partners"}
     description={"Our strong ties with industry partners ensure that Ocfit’s curriculum remains relevant and aligned with current market needs. Collaborating with leading companies, we provide not only employment opportunities but also equip individuals with practical skills for successful careers in their chosen fields."}
      partners={list}
    />
   </>
  )
}

export default IndustryPartner